import { render, staticRenderFns } from "./PermissionFlowItem.vue?vue&type=template&id=6ef39a2c&scoped=true"
import script from "./PermissionFlowItem.vue?vue&type=script&lang=js"
export * from "./PermissionFlowItem.vue?vue&type=script&lang=js"
import style0 from "./PermissionFlowItem.vue?vue&type=style&index=0&id=6ef39a2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef39a2c",
  null
  
)

export default component.exports